import { FC, ReactNode } from "react";
import styled from "@emotion/styled";
import { CSSObject } from "@emotion/react";

type Props = {
  size?: "S" | "M" | "L" | "XL";
  theme?: "LIGHT" | "DARK";
  weight?: "NORMAL" | "BOLD";
  children?: ReactNode;
  localStyles?: CSSObject;
};

const El = styled.p(
  ({ size = "S", theme = "LIGHT", weight = "NORMAL", localStyles }: Props) => ({
    margin: 0,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    fontFamily: "'Space Mono', sans-serif",
    lineHeight: 1.5,
    letterSpacing: -1,

    textShadow: "0 1px black",

    ...(theme === "LIGHT" && {
      color: "var(--light-1000)",
    }),
    ...(theme === "DARK" && {
      color: "var(--dark-1000)",
    }),
    ...(weight === "NORMAL" && {
      fontWeight: "400",
    }),
    ...(weight === "BOLD" && {
      fontWeight: "700",
    }),
    ...(size === "S" && {
      fontSize: 14,
      textShadow: "0 1px rgba(0,0,0,0.8)",
    }),
    ...(size === "M" && {
      fontSize: 16,
      textShadow: "0 2px rgba(0,0,0,0.3)",
    }),
    ...(size === "L" && {
      fontSize: 21,
      textShadow: "0 2px rgba(0,0,0,0.3)",
    }),
    ...(size === "XL" && {
      fontSize: 24,
      textShadow: "0 2px rgba(0,0,0,0.3)",
    }),
    ...localStyles,
  })
);

const Body: FC<Props> = ({
  size = "S",
  children,
  theme = "LIGHT",
  weight = "NORMAL",
  localStyles,
  ...props
}) => {
  return (
    <El
      size={size}
      weight={weight}
      theme={theme}
      localStyles={localStyles}
      {...props}
    >
      {children}
    </El>
  );
};

export default Body;
